import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2294_9991)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 13.0918,
				y: 14.0135,
				width: 10.9091,
				height: 10.9091,
				fill: "#FEFEFE"
			}),
			/* @__PURE__ */ _jsx("rect", {
				y: 14.0135,
				width: 10.9091,
				height: 10.9091,
				fill: "#FEFEFE"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 13.0918,
				y: .922363,
				width: 10.9091,
				height: 10.9091,
				fill: "#FEFEFE"
			}),
			/* @__PURE__ */ _jsx("rect", {
				y: .922363,
				width: 10.9091,
				height: 10.9091,
				fill: "#FEFEFE"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2294_9991",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0 0.922363)"
		})
	}) })]
});
export default SvgMicrosoft;
